import { ipAddress as ipAddressValidator } from "@vuelidate/validators";

export const ipAddressOrCIDR = (value: string) => {
  if (!value) return false;

  const [ip, cidr] = value.split("/");

  const isValidIp = ipAddressValidator.$validator(ip, null, null);
  if (!isValidIp) return false;

  if (cidr === undefined) return true;

  if (!cidr) return false;

  const cidrNum = parseInt(cidr, 10);
  const isValidRange = cidrNum >= 0 && cidrNum <= 32;
  const hasNoLeadingZeros = cidr === cidrNum.toString();

  return isValidRange && hasNoLeadingZeros;
};
